// ./src/hooks/useSignUpRequiresCompany.ts
//
// Does this brand ask every account for a company (ms_auth `signUpSettings`, `space.signup_requires_company`)? The sign-up
// form used to ask it; since 2026-11-02 the onboarding's first step does, and the guard holds an unnamed account there.
// ⚠ `undefined` = not answered yet, `null` = the read FAILED: unknown, never "no". Their readers say what unknown means.
// ⚠ `enabled` has no default: a read nobody needs should not happen on every page of the dashboard.
import { useEffect, useState } from 'react';

import { AuthService, type SignUpSettings } from '@/utils/api/AuthService';

export const useSignUpRequiresCompany = (enabled: boolean): boolean | null | undefined => {
  const [requiresCompany, setRequiresCompany] = useState<boolean | null | undefined>(undefined);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    let alive = true;

    AuthService.signUpSettings()
      .then((result) => {
        if (alive) {
          setRequiresCompany(result.didSucceed() && result.getDataFirst() ? !!(result.getDataFirst() as SignUpSettings).requiresCompany : null);
        }
      })
      .catch(() => {
        if (alive) {
          setRequiresCompany(null);
        }
      });

    return () => {
      alive = false;
    };
  }, [enabled]);

  return requiresCompany;
};
